<style scoped lang="scss">

</style>

<template>
  <vk-modal :show.sync="isOpen">
    <div class="uk-grid">
      <div class="uk-width-1-1 uk-margin-top">
        <h2>Add School</h2>
      </div>
      <div class="uk-width-1-1 uk-margin-top">
        <label for="organization_name">School Name</label>
        <validated-section :errors="errors" field="organization_name">
          <input v-model="form.organization_name" class="uk-input uk-form-large">
        </validated-section>
      </div>


    </div>

    <div slot="footer" class="uk-text-right">
      <vk-button class="uk-margin-small-right" @click="isOpen = false">Cancel</vk-button>
      <vk-button type="primary" @click="save">Save</vk-button>
    </div>
  </vk-modal>
</template>

<script>
import ValidatedSection from "../Common/ValidatedSection.vue";

export default {
  name: "CreateSchoolModal",
    components: {ValidatedSection},
  data() {
    return {
      loading: false,
      isOpen: false,
      errors: {},
      applicationId: null,
      form: {
        organization_name: '',
      },
    }
  },
  async mounted() {

  },
  methods: {
    open(appId) {
      this.applicationId = appId;
      this.form = { organization_name: '' };
      this.isOpen = true;
    },

    async save() {
      try {
        let { data } = await axios.post('/api/hope/jobs/applications/'+this.applicationId+'/schools', {
          organization_name: this.form.organization_name,
        })
        console.log('got data', data);
        this.$emit('updated', data.school);
        this.isOpen = false;
      } catch (e) {
        if (e.response && e.response.data) {
          this.errors = e.response.data.errors;
          if(this.errors.organization_name && this.errors.organization_name[0] === "The organization name has already been taken.") {
              this.errors.organization_name = ['The school name has already been taken. Please select it from the search menu or use a different name.']
          }
        }
      }
    }
  }
}
</script>
